module.exports = __webpack_public_path__ + "static/media/esclusivita.d538ac24.odt";